



































































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import AppConsts from '@/lib/appconst';
import _ from 'lodash'
class  PageTransportRequest extends PageRequest{
    keyword:string;
    type: string;
    status: string; 
}

@Component
export default class Transport extends AbpBase{
    pagerequest:PageTransportRequest=new PageTransportRequest();
    items=[];
     pageSize = AppConsts.pageSize;
    currentPage = 1;
     selectedLocationIds=[];
     get store () {
      return this.$store.state.locationLocking;
    }
     get loading() {
      return this.store.loading;
    }
   
    get totalCount() {
      return Util.isNull(this.items)?0: this.items.length;
    }

    get transportTypes()
    {
      var transportTypes = this.$store.state.transport.transportTypes;
      this.pagerequest.type = Util.isNull(transportTypes) || transportTypes.length<=0?'': transportTypes[0].code;
      return transportTypes;
    }
    get transportStatuses()
    {
      var transportStatuses = this.$store.state.transport.transportStatuses;
      this.pagerequest.status = Util.isNull(transportStatuses) || transportStatuses.length<=0?'': transportStatuses[0].id;
      return transportStatuses;
    }
    pageChange(page: number) {
      this.currentPage = page;
    }
    pagesizeChange(pagesize: number) {
      this.pageSize=pagesize;
    }
    async searchTransports() {
        await this.$store.dispatch({
            type:'locationLocking/searchTransports',
            data: this.pagerequest
        }).then(re=>
        {
            this.items = re.items;
        });
    }
    get list(){
      return Util.pagingItems(this.items,this.pageSize,this.currentPage);
    }
   onSelect (selection, row) {
      this.$emit('on-select', selection, row)
    }
    onSelectCancel (selection, row) {
      this.$emit('on-select-cancel', selection, row)
    }
    onSelectAll (selection) {
      this.$emit('on-select-all', selection)
    }
    onSelectionChange (selection) {
      this.$emit('on-selection-change', selection)
      _.forEach(this.list, (o) => {
        var itemSelected = _.find(selection, function (x) { return x.id === o.id });
        if(itemSelected){
          o._checked = true;
        }else{
          o._checked = false;
        }
      });
        var selectedItems = this.items.filter((item) =>  item._checked);
        this.selectedLocationIds = _.map(selectedItems,'id');
        this.$emit('update:selectedLocationIds', this.selectedLocationIds)
    }
    columns= [
        {
              type: 'selection',
              width: 60,
              align: 'center',
              key:'selected'
          },
          {
              title:Util.L('Code'),
              width: 200,
              key:'code'
          },
          {
              title:Util.L('Type'),
              width: 150,
              key:'typeName'
          },
          {
              title:Util.L('Status'),
              key:'statusName'
          }
        ]
     created(){
    }
}
